import { useParams } from "react-router-dom"
import { useFlashDetail } from "@/hooks/useFlashDetail"
import { useArtists } from "@/hooks/useArtists"
import { useDynamicMetaTags } from "@/hooks/useDynamicMetaTags"
import { formatArtistDisplayName } from "@/lib/utils"
import { useToast, Toast } from "@/components/ui/toast"
import { FlashDetailContent } from "@/components/details/FlashDetailContent"

export default function FlashDetailPage() {
  const { flashId } = useParams<{ flashId: string }>()
  const { flash } = useFlashDetail(flashId)
  const { artists } = useArtists(flash ? [flash.artistId] : [])
  const { toast, hideToast } = useToast()

  const artist = artists[0]

  useDynamicMetaTags({
    title: flash && artist ? `${formatArtistDisplayName(artist) || artist.displayName} - Flash Tattoo` : undefined,
    description: flash ? `Check out this flash tattoo${flash.minPrice ? ` starting from ${flash.minPrice}€` : ''}${flash.minSize ? `, size ${flash.minSize}` : ''}` : undefined,
    image: flash?.imageUrl,
    url: flash ? `https://getmoretats.com/flashes/${flash.id}` : undefined,
    type: 'article'
  })

  if (!flashId) return null

  return (
    <>
      <div style={{ paddingBottom: 'var(--bottom-nav-offset)' }}>
        <FlashDetailContent flashId={flashId} />
      </div>
      <Toast {...toast} onClose={hideToast} />
    </>
  )
}